import React from 'react';
import { PaypalPanel } from './existing-paypal-payment-method';

export const PaypalPaymentMethodPanel: React.FC<{ emailID: string }> = ({ emailID }) => (
  <div className="paypal-payment-method-panel">
    <PaypalPanel emailID={emailID} />
  </div>
);
